document.addEventListener('DOMContentLoaded', function() {
  const accordions = document.querySelectorAll('.accordion');

  accordions.forEach(acc => {
    acc.addEventListener('show.bs.collapse', function(e) {
      const item = e.target.closest('.accordion-item');
      if (item) { item.classList.add('active'); }
    });

    acc.addEventListener('hide.bs.collapse', function(e) {
      const item = e.target.closest('.accordion-item');
      if (item) { item.classList.remove('active'); }
    });
  });
});